// -*- Mode: rjsx -*-
import React, { useState }  from 'react';
import { useSelector } from 'react-redux';

import { FancyDate, AvatarImage } from '../../../ui';
import Grid from '@mui/material/Grid';
import { EMPTY_REQUEST } from '../../request';

import { FHTheme } from '../../../ui';

class TaskListItemFlags extends React.Component {
    
    render() {
	    let request = this.props.task;

	    let flags = [];

	    if(request.flags.white_gloves)
	        flags.push(<span key="flag-new-customer" className="label new-customer">New Customer!</span>);

	    if(request.flags.vip)
	        flags.push(<span key="flag-vip" className="label vip">VIP</span>);

	    if(request.claimed_by && request.claimed_by.probation)
	        flags.push(<span key="new-assistant" className="label noob tooltip" title="This assistant is new, mentor them well.">New Assistant</span>);

	    
	    return (
	        <div className="task-flags">
	          { flags.map((o) => o ) }
	        </div>
	    );
    }
}

function TaskListItemUser(props) {
	// return <Link to={"/admin/user/" + props.user.key}>{props.user.name} link</Link>;

	return props.user ? <a href={props.user.url}>{props.user.name}</a> : <em>&mdash;</em>;
    
}

class TaskListItemCreatedBy extends React.Component {
    render() {
	    let user = this.props.task.user;
	    let task = this.props.task;

	    if(task.odo) {
	        /* Special link and avatar if it's an ODO request */
	        user.avatar_url = "/images/odo-mini.png";
	        user.url = '/admin/project/' + task.permissions[0];
	    }

	    return (<TaskListItemUser user={user} />);
	    
    }
}

class TaskListItemClaimedBy extends React.Component {
    render() {
	    let user = this.props.task.claimed_by;

	    if (!user)
	        return null;
	    let task = this.props.task;	
	    // FIXME: Use ui.Avatar
	    let style = {
	        display: 'inline'
	    };
	    return (
	        <div style={style}>
	          <span style={{ paddingLeft: 5, marginLeft: 5, borderLeft: "1px solid #EBEBEB" }}>Claimed by&nbsp;</span>
	          <TaskListItemUser user={user} />
	        </div>);
	    
    }
}


class TaskListItemInfo extends React.Component {
    render() {
	    let task = this.props.task;
        let title = "$" + task.payment.price;
	    let price = <em>{ task.payment.price }</em>;
        
	    if(task.call) {
            let price_per_minute = window.pageVariables.user.call_price_per_minute || 0.17;
	        price = <em>{price_per_minute + '/min'}</em>;
            title = parseInt(price_per_minute * 100) + " cents per minute of call time";
	    }

        // div className="price"><span>$</span><span className="request_price add-tooltip" title={title}>        
	    if (task.is_tutorial)
	        price = null;
        
	    return (
            <div className="task-info">
              
              <Grid direction="row"  container justifyContent="space-between">
                <Grid item xs={6} >
	              <TaskListItemCreatedBy task={task} /> &mdash;
	              <FancyDate date={task.date_created} icon={false} />
                </Grid>
                <Grid item xs={6} style={{ textAlign: "right" }}>
                  <span style={{ color: FHTheme.palette.money,
                                 backgroundColor: FHTheme.palette.moneyBg,
                                 borderRadius: 5,
                                 paddingLeft: 8,
                                 paddingRight: 8,
                                 fontSize: "200%",
                                 marginRight: 16 }} >${ price }</span>
                </Grid>

              </Grid>
	          

	        </div>
        );
    }

}

class TaskListItemFooterLastUpdated extends React.Component {
    render() {
	    let task = this.props.task;
	    if (!task.last_action) {
	        return null;
	    }
	    
	    let actionMap = [];
	    actionMap[0] =  "Submitted";
	    actionMap[1] =  "Note from Assistant";
	    actionMap[2] =  "Note from Client";
	    actionMap[3] =  "Note from Mentor";
	    actionMap[4] =  "Approved by Mentor";
	    actionMap[5] =  "Payment Requested";
	    actionMap[6] =  "Mentor Approved Payment Request";
	    actionMap[7] =  "User Approved Payment";
	    actionMap[8] =  "User Declined Payment";
	    actionMap[9] =  "Payment Succeeded";
	    actionMap[10] = "Payment Failed";
	    
	    return (
            <div className="left">
	          <span>{actionMap[task.last_action]}</span> &rarr;
	          <FancyDate date={task.date_updated} />
	        </div>
	    );

    }
}

class TaskListItemFooter extends React.Component {
    render() {
	    let task = this.props.task;

	    let godNote = null;
	    if (task.god_note) {
	        godNote = <div className="god-note"><br />{ task.god_note } &mdash; <em>(Internal note from manager)</em></div>;
	    }

	    let style = {

	    };
	    return (
            <div className="task-bottom cf" style={style}>

	          <TaskListItemClaimedBy task={task} />

	          <TaskListItemFooterLastUpdated task={task} />
	          
              <div className="status right" style={style}>
		        { task.status_name }
	          </div>
	          { godNote }
	        </div>
	    );
    }
}


class TaskListItemPreview extends React.Component {
    constructor(props) {
	    super(props);
	    this.goToTask = this.goToTask.bind(this);
	    this.state = { content: null, loadingFullTask: false };
	    
    }

    goToTask(e) {
	    e.preventDefault();
	    e.stopPropagation();
	    this.setState({ loadingFullTask: true });
        if(!this.props.gotoFullTask)
            window.location.href = this.props.task.url;
        else
	        this.props.gotoFullTask(e);
    }

    componentWillMount() {
	    let task = this.props.task;
	    let self = this;
	    window.$.get('/api/v1/assistant/request/' + task.key + '/',
		             function(data) {
			             if(!data.response) return;
			             try {
			                 self.setState({ 'content': data.response.request.content });
			             }
			             catch (ex) {
			                 console.log("probably unmounted.");
			             }
		             });
    }
    
    render() {
	    let content = this.state.content;
	    let style = {
	        mainSpinnerContainer: {
		        margin: "10px",
		        padding: "10px",
		        textAlign: "center"
	        },
	        content: {
		        marginTop: "1em",
		        marginBottom: "1em",                
		        // padding: "10px"		
	        },
	        buttonContainer: {
		        // borderBottom: "solid 1px #efefef",
		        marginLeft: "10px",
		        marginRight: "10px",
		        paddingLeft: "10px",
		        paddingRight: "10px",
		        textAlign: "right",
		        verticalAlign: "middle"
	        }
	    };

	    let goToTaskLinkText = "View task";
	    if(this.props.task.call) {
	        goToTaskLinkText = "Make Call";
	    }
	    let spinner = <div><img src="/images/gifs/spinner.gif" alt="loading" /></div>;
	    if(this.state.loadingFullTask) {
	        goToTaskLinkText = "Loading";
	    }

	    let goToTask = <a href={this.props.task.url} onClick={this.goToTask} className="btn margin-bottom-10">{ goToTaskLinkText }</a>;
	    if(this.props.noAction)
	        goToTask = null;
	    if (!content) {
	        return (
		        <div style={style.content}>
		          <div style={style.mainSpinnerContainer}>
		            { spinner }
		          </div>
		        </div>
	        );
	    }

	    let contentDiv = null;
	    if(this.props.task.odo && this.props.task.call) {
	        let json = JSON.parse(content);
	        let context = json.context;
	        content = "Call task!";
	        try {
		        if(context) {
		            content = (
			            <div>
			              Call {context.who.name} to {context.goal}
			            </div>
		            );
		        }
	        }
	        catch(err) {
		        console.log(err);		
	        }
	        contentDiv = <div style={style.content}>{content}</div>;
	    }
	    else {
	        contentDiv = (<div style={style.content}
			                           dangerouslySetInnerHTML={{__html: content}} >
			                       </div>);
	    }

	    return (
	        <div>

	          {contentDiv}
	          
	          <div style={style.buttonContainer}>
		        { goToTask }
	          </div>

	        </div>
	    );
    }
}



function TaskListItem (props) {
    
	let row_id = props.task + "-" + Math.round(Math.random() * 10000);
    // const [ loadFullTask, doLoadFullTask] = useState(false);
    const [ showingPreview, setShowPreview] = useState(false);
    
    const request = useSelector((state) => {
		//  console.log("Key: %o", props.task);
		//  console.log("state requets: %o", state.queue.byRequestKey);
		//  console.log("From keys: %o", state.queue.byRequestKey[props.task]);
        //  console.log("request.useselector: props:task: %o, state: %o", props.task, state);

        return state.queue.byRequestKey[props.task] || EMPTY_REQUEST;
    });

    function doShowPreview(e) {
        // if it's a link, let it do it's thing.
        if(!e.target.href) {
            e.preventDefault();
            setShowPreview(true);
            
        }
    }


	let style = {
	    inline: {
		    display: "inline"
	    },
	    black: {
		    color: "black"
	    },
	    bonus: {
		    backgroundColor: "#fdf3c5",
		    padding: "0px 5px 0px 5px",
		    borderRadius: 3
	    },
		link: {
			textTransform: "none",
			color: "black",
			fontSize: "1.25em",
			fontFamily: "helvetica, sans-serif"
	//		textDecoration: "underline"
		}
	};

//	console.log("request: %o", request);
	let permissionClasses = request.permissions.map( o => "permission-" + o );
	let spinnerImage = null;
    
	let title = request.title;
	let TASK_TITLE_LIMIT = 60;
	if (title && title.length > TASK_TITLE_LIMIT) {
	    title = title.substring(0, TASK_TITLE_LIMIT) + "...";
	}

	let classes = permissionClasses || [];
	let titleIcon = null;
	if(request.call)
	    titleIcon = <i className="fh-icon-phone"></i>;
	classes.push('call-request');
	if(request.odo)
	    classes.push('task-odo');

	// let titleLink = <span>{titleIcon} {title}</span>;
	let titleLink = <a style={style.link} href={request.url} onClick={() => false }>{titleIcon} {title}</a>;


    let isHidden = null;
    if(request.hidden) {
        if(window.pageVariables.manager)  {
            isHidden = <em style={{color: "#aaa"}}>(hidden from assistants)</em>;
        }
        else {
            classes.push("hidden");
        }
    }

	return (
	    <div className={"task-row cf request-" + request.key + " " + classes.join(" ") }
		     onClick={doShowPreview}
		     id={row_id}
             key={'key-' + row_id}
		     data-request={request.key}>
          
	      <h6 className="left" style={style.inline}>
	        {titleLink}
	      </h6> { isHidden } { spinnerImage }



	      <TaskListItemFlags task={request} />
	      <TaskListItemInfo task={request} />
          { showingPreview ? <TaskListItemPreview task={request}/> : null }          
	      <TaskListItemFooter task={request} />
	      
	    </div>
	);

}


function List(props) {
	let tasks = props.tasks;
//    console.log("list.props; %o", props);
	let style = {
	    small: {
		    textAlign: "center",
		    fontSize: "70%",
		    color: "#ddd"
	    }
	};

	// console.log("Task List: %o", this);
	let title = "Waiting for tasks...";
	if (props.defaultTitle)
	    title = props.defaultTitle;

    // fixme: this `if` is gross.... it should be an empty array.
	if(!tasks.length) {
	    return (<div key="key-none">
		          <p className="faded-message">{title}<br /><span style={style.small}>This section automatically updates</span></p>
		        </div>);
	}

	return( 
	    <div>
	      {
              tasks.map( (req) =>
                  <TaskListItem
                    queue={props.queue}
                    returnTo={props.returnTo}
                    noAction={props.noAction}
                    key={req}
                    task={req} /> )
          }
	    </div>
	);
}


export { List };
